// UserSessionTick.jsx
import React from 'react';
// import PropTypes from 'prop-types';

import trackMixpanel, {
  EventTypes,
  getDataFromPath,
} from '../resource/mixpanel.js';

const MIXPANEL_INTERVAL_SECONDS = 300; // TODO: remote config

export class UserSessionTick extends React.PureComponent {
  sessionDuration = 1;
  mixpanelInterval = null;
  componentDidMount() {
    clearInterval(this.mixpanelInterval);
    this.mixpanelInterval = setInterval(() => {
      const payload = getDataFromPath({
        pathname: location.pathname,
      });
      trackMixpanel({
        type: EventTypes.USER_SESSION_TICK,
        payload: {
          ...payload,
          sessionDuration: this.sessionDuration * MIXPANEL_INTERVAL_SECONDS,
          windowInnerWidth: window.innerWidth,
          windowInnerHeight: window.innerHeight,
        },
      });
      this.sessionDuration += 1;
    }, MIXPANEL_INTERVAL_SECONDS * 1000);
  }
  componentWillUnmount() {
    clearInterval(this.mixpanelInterval);
  }
  render() {
    return null;
  }
}

UserSessionTick.propTypes = {};

UserSessionTick.defaultProps = {};

export default UserSessionTick;
